import { useCallback, useState } from "react";

import CopyIcon from "../../icons/CopyIcon"
import CopiedIcon from "../../icons/CopiedIcon";
import Button from "../Form/Button";

const Copy = (props) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = useCallback(() => {

    if (typeof props.text === "object") {
      const formattedJson = JSON.stringify(props.text, null, 2);
      navigator.clipboard.writeText(formattedJson).then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2500);
      });
    } else {
      navigator.clipboard.writeText(props.text).then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2500);
      });
    }
  }, [props.text]);

  return (
    <div className={`w-full flex items-center rounded-[5px] ${props.className}`}>
      {
        props.label ? (
          <>
            <div className={"w-[80px] flex flex-row items-center font-semibold text-sm gap-x-1"}>
              <span className="inline-block whitespace-nowrap">{props.label}</span>
            </div>
            <div className={`w-[calc(100%_-_100px)] md:w-[calc(100%_-_97px)] text-xs md:text-sm ${props.labelColor ? `${props.labelColor}` : " text-dark-gray"} break-all ${props.multiline ? "" : "truncate"}`}>
              <span className={`${props.hideText ? "hidden" : "flex"}`}>
                {typeof props.text === "object" ? JSON.stringify(props.text) : props.text}
              </span>
            </div>
            <Button width="18px" height="18px" variant="ghost" onClick={copyToClipboard}>
              <span className="max-w-[18px] max-h-[18px] text-gray-mid w-[16px] block">
                {
                  isCopied ? <CopiedIcon /> : <CopyIcon />
                }
              </span>
            </Button>
          </>
        ) : (
          <div className="w-full flex flex-row justify-between">
            <div className={`w-[calc(100%_-_26px)] overflow-y-auto text-xs md:text-sm text-dark break-all font-mono ${props.multiline ? "" : "truncate"}`}>
              <span className={`${props.hideText ? "hidden" : "flex"}`}>
                {typeof props.text === "object" ? (
                  <pre className="pl-[12px] py-[8px]">{JSON.stringify(props.text, null, 2)}</pre>
                ) : (
                  props.text
                )}
              </span>
            </div>
            <Button width="18px" height="18px" variant="ghost" onClick={copyToClipboard}>
              <span className="max-w-[18px] max-h-[18px] text-[#FFFFFF] block w-[16px]">
                {isCopied ? <CopiedIcon /> : <CopyIcon />}
              </span>
            </Button>
          </div>
        )
      }
    </div>
  );
};

export default Copy;
